export enum TenantConsentStatusAPIResponse {
  NoAction = 'noAction',
  AskedIfRequired = 'askedIfRequired',
  RequiredNoAction = 'requiredNoAction',
  Requested = 'requested',
  Received = 'received',
  NotRequired = 'notRequired',
}
